<template>
    <span />
</template>

<script>
import { mapGetters } from 'vuex';
import { MILLIS_IN_SECOND } from '@/constants/global';
export default {
    POLLING_PERIOD_IN_MILLIS: 30 * MILLIS_IN_SECOND,
    data() {
        return {
            interval: null
        };
    },

    computed: {
        ...mapGetters(['firebaseEnabled'])
    },

    watch: {
        firebaseEnabled: {
            handler() {
                if (this.firebaseEnabled) {
                    this.interval && clearInterval(this.interval);
                } else {
                    this.pollClubs();
                }
            }
        }
    },

    methods: {
        pollClubs() {
            setInterval(() => {
                this.$store.dispatch('fetchUserClubs', true);
            }, this.$options.POLLING_PERIOD_IN_MILLIS);
        }
    }
};
</script>
